export default __webpack_public_path__ + "static/dark-island-7bb8c2777767720d25fa692fc9bdac24.jpg";